import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ModalsModule } from '@web/shared/modals/modals.module';
import { CopyPageModalComponent } from '@web/layout/drawers/page-drawer/modals/copy-page-modal/copy-page-modal.component';
import { DeletePageModalComponent } from '@web/layout/drawers/page-drawer/modals/delete-page-modal/delete-page-modal.component';
import { EditPageSettingsModalComponent } from '@web/layout/drawers/page-drawer/modals/edit-page-settings-modal/edit-page-settings-modal.component';

import { PageDrawerComponent } from './page-drawer.component';
import { PagesDrawerListComponent } from './pages-drawer-list/pages-drawer-list.component';
import { PagesDrawerItemComponent } from './pages-drawer-list/pages-drawer-item/pages-drawer-item.component';

const MODALS = [CopyPageModalComponent, DeletePageModalComponent, EditPageSettingsModalComponent];

const COMPONENTS = [PageDrawerComponent, PagesDrawerListComponent, PagesDrawerItemComponent];

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        ModalsModule,
        BsDropdownModule,
        TranslateModule,
        TooltipModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDropzoneModule,
        ...COMPONENTS,
        ...MODALS,
    ],
    exports: [PageDrawerComponent],
})
export class PageDrawerModule {}
